import { PASSWORD_RESET_REQUIRED_STORAGE_KEY } from './authRequest';

export const COMMERCE_SESSION_KEYS = [
  'authToken',
  'user',
  'branchId',
  'channelId',
  'commerceName',
  'commerceLogo',
  'branchName',
  'config',
  PASSWORD_RESET_REQUIRED_STORAGE_KEY,
];

export function clearCommerceSessionStorage() {
  COMMERCE_SESSION_KEYS.forEach((key) => localStorage.removeItem(key));
}
